// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Theme Configuration
// ═══════════════════════════════════════════════════════════════════════════
// Edit colors, fonts, and visual styling here.
// ═══════════════════════════════════════════════════════════════════════════

export const THEMES = {
    light: {
        name: 'Canvas',
        id: 'light',
        colors: {
            background: '#F6F9F8',      // Still White
            text: '#1E2A2A',            // Ink Black
            textSecondary: '#7C8A8A',   // Ash Grey
            accent: '#2FA4A9',          // Quiet Teal
            surface: '#FFFFFF',
            heart: '#F5A5A5',
        },
    },

    dark: {
        name: 'Vespers',
        id: 'dark',
        colors: {
            background: '#0A1212',      // Deep Ink
            text: '#F6F9F8',            // Still White
            textSecondary: '#9AA6A6',
            accent: '#3DC4C4',
            surface: '#1E2626',
            heart: '#F5A5A5',
        },
    },

    dawn: {
        name: 'Dawn',
        id: 'dawn',
        colors: {
            background: '#F8FAFA',
            text: '#1A3030',
            textSecondary: '#5A7575',
            accent: '#5E9EA0',
            surface: '#FFFFFF',
            heart: '#E89090',
        },
    },

    lavender: {
        name: 'Lavender',
        id: 'lavender',
        colors: {
            background: '#F7F6F9',
            text: '#353040',
            textSecondary: '#757085',
            accent: '#8B7DA8',
            surface: '#FFFFFF',
            heart: '#E89BAE',
        },
    },

    rose: {
        name: 'Rose',
        id: 'rose',
        colors: {
            background: '#FAF7F8',
            text: '#403538',
            textSecondary: '#857075',
            accent: '#A67C89',
            surface: '#FFFFFF',
            heart: '#DB7B8C',
        },
    },
};

// ─────────────────────────────────────────────────────────────────────────
// TYPOGRAPHY
// ─────────────────────────────────────────────────────────────────────────

export const TYPOGRAPHY = {
    // Primary font for verse text (loaded from Google Fonts)
    verseFontFamily: '"Crimson Pro", Georgia, serif',

    // UI font for buttons, labels
    uiFontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',

    // Verse text sizing (responsive)
    verseFontSize: 'clamp(1.5rem, 5vw, 2.2rem)',
    verseLineHeight: 1.6,

    // Reference text (book, chapter, verse)
    referenceFontSize: '0.9rem',

    // UI elements
    uiFontSize: '0.875rem',
    buttonFontSize: '0.8rem',
};

// ─────────────────────────────────────────────────────────────────────────
// ANIMATIONS
// ─────────────────────────────────────────────────────────────────────────

export const ANIMATIONS = {
    // Page/card transitions
    transitionDuration: '0.3s',
    transitionEasing: 'cubic-bezier(0.4, 0, 0.2, 1)',

    // Heart animation
    heartPopDuration: '0.4s',

    // Fade in for new verses
    verseFadeIn: '0.5s',

    // Scroll snap behavior
    scrollBehavior: 'smooth',
};

// ─────────────────────────────────────────────────────────────────────────
// SYMBOLS (decorative overlays)
// ─────────────────────────────────────────────────────────────────────────

export const SYMBOLS = {
    enabled: true,

    // Probability of showing a symbol (0-1)
    probability: 0.15,

    // Available symbols
    list: ['seed', 'flame', 'wind', 'path', 'tear', 'light', 'water'],

    // Opacity for symbol overlays
    opacity: 0.08,
};

export default { THEMES, TYPOGRAPHY, ANIMATIONS, SYMBOLS };
